/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import "animate.css";
import TrackVisibility from "react-on-screen";

import "./Contact.css";
import { useTranslation } from "react-i18next";

export default function Contact(): JSX.Element {
  const { t } = useTranslation();

  const formInitialDetails = {
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  };

  const [aboutModalShow, setAboutModalShow] = useState<boolean>(false);
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [, setButtonText] = useState("Send");

  const onFormUpdate = (category: string, value: string): void => {
    setFormDetails({
      ...formDetails,
      [category]: value,
    });
  };

  const handleSubmit = (e: React.ChangeEvent): void => {
    e.preventDefault();
    setButtonText("Sending...");
    void fetch("https://studytour.io/api/email/send", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify(formDetails),
    }).then((data) => {
      setAboutModalShow(true);
      setButtonText("Send");
    });
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <img
                  className={isVisible ? "animate__animated animate__zoomIn" : ""}
                  src={contactImg}
                  alt="Contact Us"
                />
              )}
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>{t("Get In Touch")}</h2>
                  <form onSubmit={() => handleSubmit}>
                    <Row>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="text"
                          value={formDetails.firstName}
                          placeholder={t("First Name")}
                          onChange={(e) => {
                            onFormUpdate("firstName", e.target.value);
                          }}
                        />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="text"
                          value={formDetails.lastName}
                          placeholder={t("Last Name")}
                          onChange={(e) => {
                            onFormUpdate("lastName", e.target.value);
                          }}
                        />
                      </Col>
                      <Col size={12} sm={12} className="px-1">
                        <input
                          type="email"
                          value={formDetails.email}
                          placeholder={t("Email")}
                          onChange={(e) => {
                            onFormUpdate("email", e.target.value);
                          }}
                        />
                      </Col>
                      <Col size={12} className="px-1">
                        <textarea
                          rows={6}
                          value={formDetails.message}
                          placeholder={t("Message")}
                          onChange={(e) => {
                            onFormUpdate("message", e.target.value);
                          }}
                        ></textarea>
                        <button type="submit" onClick={handleSubmit}>
                          <span>{t("Send")}</span>
                        </button>

                        <div className={aboutModalShow ? "about-modal active" : "about-modal"}>
                          <div
                            className={aboutModalShow ? "overlay active" : "overlay"}
                            onClick={() => {
                              setAboutModalShow(false);
                            }}
                          ></div>
                          <div className={aboutModalShow ? "about-modal-content active" : "about-modal-content"}>
                            <h2>{t("Message Sent Successfully!")}</h2>
                            <p>{t("Thank you for your interests! We will be contacting you shortly.")}</p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
